import { render, staticRenderFns } from "./RibbonList.vue?vue&type=template&id=6683047f&scoped=true&"
import script from "./RibbonList.vue?vue&type=script&lang=js&"
export * from "./RibbonList.vue?vue&type=script&lang=js&"
import style0 from "./RibbonList.vue?vue&type=style&index=0&id=6683047f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683047f",
  null
  
)

export default component.exports